import React, { useState, useEffect } from "react";
import "./ContactMail.css";

export default function ContactMail({ onClose, onMailSent }) {
  const [senderEmail, setSenderEmail] = useState(() => {
    return localStorage.getItem('contactEmail') || '';
  });
  const [subject, setSubject] = useState(() => {
    return localStorage.getItem('contactSubject') || '';
  });
  const [message, setMessage] = useState(() => {
    return localStorage.getItem('contactMessage') || '';
  });
  const [sending, setSending] = useState(false);

  // Sauvegarder dans localStorage à chaque changement
  useEffect(() => {
    localStorage.setItem('contactEmail', senderEmail);
  }, [senderEmail]);

  useEffect(() => {
    localStorage.setItem('contactSubject', subject);
  }, [subject]);

  useEffect(() => {
    localStorage.setItem('contactMessage', message);
  }, [message]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSending(true);

    try {
      // Configuration EmailJS
      const serviceID = 'YOUR_SERVICE_ID'; // À remplacer
      const templateID = 'YOUR_TEMPLATE_ID'; // À remplacer
      const publicKey = 'YOUR_PUBLIC_KEY'; // À remplacer

      // Si EmailJS n'est pas configuré, utiliser fetch direct vers un endpoint
      const response = await fetch('https://api.emailjs.com/api/v1.0/email/send', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          service_id: serviceID,
          template_id: templateID,
          user_id: publicKey,
          template_params: {
            from_email: senderEmail,
            subject: subject,
            message: message,
            to_email: 'k.berrehouc@gmail.com'
          }
        })
      });

      if (response.ok) {
        console.log("✅ Mail envoyé avec succès!");
        // Vider les champs après envoi réussi
        localStorage.removeItem('contactEmail');
        localStorage.removeItem('contactSubject');
        localStorage.removeItem('contactMessage');
        
        setSending(false);
        onClose();
        onMailSent();
      } else {
        throw new Error('Erreur lors de l\'envoi');
      }
    } catch (error) {
      console.error("❌ Erreur lors de l'envoi du mail:", error);
      alert("Erreur lors de l'envoi du message. Veuillez réessayer.");
      setSending(false);
    }
  };

  return (
    <div className="contact-mail-overlay" onClick={onClose}>
      <div className="contact-mail-window" onClick={(e) => e.stopPropagation()}>
        <div className="contact-mail-topbar">
          <div className="contact-mail-buttons">
            <span className="close" onClick={onClose}></span>
            <span className="minimize"></span>
            <span className="maximize"></span>
          </div>
          <span className="contact-mail-title">Nouveau message</span>
        </div>
        
        <form onSubmit={handleSubmit} className="contact-mail-content">
          <div className="mail-field">
            <label>Votre email</label>
            <input
              type="email"
              value={senderEmail}
              onChange={(e) => setSenderEmail(e.target.value)}
              placeholder="votre.email@example.com"
              required
              autoFocus
            />
          </div>

          <div className="mail-field">
            <label>Objet</label>
            <input
              type="text"
              value={subject}
              onChange={(e) => setSubject(e.target.value)}
              placeholder="Objet du message"
              required
            />
          </div>
          
          <div className="mail-field message-field">
            <label>Message</label>
            <textarea
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              placeholder="Écrivez votre message..."
              required
            />
          </div>
          
          <div className="mail-actions">
            <button type="submit" className="send-button" disabled={sending}>
              {sending ? "Envoi..." : "Envoyer"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
